import './FleetCard.scss';
import Button from '../../../ui/Button/Button';
import React from 'react';

export default function FleetCard({ card }) {
  return (
    <div className={'fleet-card-support'}>
      <div className={'card'}>
        <div>
          <div className={'card_content'}>
            <div>
              <h3 className={'card_content_title'}>{card?.title?.value}</h3>
              <p className={'card_content_text'}>{card?.desc?.value}</p>
            </div>
          </div>
        </div>
        <div className={'card_buttonContainer'}>
          <a href={card?.buttonUrl?.value?.href}>
            <Button className={'card_buttonContainer_button'} isShowTooltip={false}>
              {card?.buttonText?.value}
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
